<template>
    <v-form class="stylish-self-employed-form">
      <v-row v-for="(business, index) in selfEmployedOccupation" :key="index" class="mb-6">
        <!-- Business Type and Business Name in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Type"
            v-model="business.businessType"
            outlined
            dense
            class="form-field"
            color="purple"
            hide-details="auto"
            prepend-icon="mdi-briefcase"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Name"
            v-model="business.businessName"
            outlined
            dense
            class="form-field"
            color="purple"
            hide-details="auto"
            prepend-icon="mdi-store"
          />
        </v-col>
  
        <!-- Role in Business and Business Address in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Role in Business"
            v-model="business.roleInBusiness"
            outlined
            dense
            class="form-field"
            color="purple"
            hide-details="auto"
            prepend-icon="mdi-account-cog"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Address"
            v-model="business.businessAddress"
            outlined
            dense
            class="form-field"
            color="purple"
            hide-details="auto"
            prepend-icon="mdi-map-marker"
          />
        </v-col>
  
        <!-- Business Phone Number in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Phone Number"
            v-model="business.businessPhoneNumber"
            outlined
            dense
            class="form-field"
            color="purple"
            hide-details="auto"
            prepend-icon="mdi-phone"
          />
        </v-col>
      </v-row>
  
      <!-- Add Another Business Button -->
      <v-btn
        color="indigo"
        outlined
        @click="addBusiness"
        class="add-business-btn"
      >
        <v-icon left>mdi-plus-circle</v-icon> Add Another Business
      </v-btn>
    </v-form>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selfEmployedOccupation: [
          {
            businessType: "",
            businessName: "",
            roleInBusiness: "",
            businessAddress: "",
            businessPhoneNumber: "",
          },
        ],
      };
    },
    methods: {
      addBusiness() {
        this.selfEmployedOccupation.push({
          businessType: "",
          businessName: "",
          roleInBusiness: "",
          businessAddress: "",
          businessPhoneNumber: "",
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .stylish-self-employed-form {
    max-width: 900px;
    margin: 30px auto;
    padding: 20px;
    background: linear-gradient(135deg, #e8f4fc, #cfd8dc);
    border-radius: 16px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid #cfd8dc;
  }
  
  .form-field {
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .form-field:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }
  
  .v-text-field input {
    font-size: 1rem;
    font-weight: 500;
  }
  
  .v-text-field.v-text-field--outlined {
    background-color: #ffffff;
    border-radius: 12px;
  }
  
  .v-text-field .v-input__append-inner {
    padding-right: 15px;
  }
  
  .v-text-field .v-input__prepend-inner {
    padding-left: 15px;
  }
  
  .v-btn {
    background-color: #3f51b5;
    color: white;
    padding: 12px 20px;
    border-radius: 50px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s ease;
  }
  
  .v-btn:hover {
    background-color: #303f9f;
  }
  
  .add-business-btn {
    margin-top: 20px;
    text-transform: none;
    font-size: 1rem;
  }
  </style>
  